
import { Client } from "@/lib/supabase";

export const formatPhoneForWhatsApp = (phone: string) => {
  if (!phone) return '';
  const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
  if (cleanPhone.startsWith('0')) {
    return `+39${cleanPhone}`;
  }
  if (!cleanPhone.startsWith('+')) {
    return `+39${cleanPhone}`;
  }
  return cleanPhone;
};

export interface ClientTableActionsProps {
  client: Client;
  onEdit: (client: Client) => void;
  onDelete: (client: Client) => void;
  onCreateAccount?: (client: Client) => void;
  isCreatingAccount?: string | null;
  showActions?: boolean;
}

